import React from "react";
import ReactDOM from "react-dom/client";
import "@financial-edge/shared/index.css";
import { ErrorBoundary } from "@financial-edge/shared";
import App from "./App";
import "./App.css";

const THEME_STORAGE_KEYS = [
    "financialEdgeThemePreference",
    "xPortalThemePreference",
    "theme",
];
const VALID_THEME_PREFERENCES = new Set(["light", "dark", "system"]);

function readStoredThemePreference() {
    if (typeof window === "undefined") {
        return "system";
    }

    const queryTheme = new URLSearchParams(window.location.search).get("theme");

    if (VALID_THEME_PREFERENCES.has(queryTheme)) {
        return queryTheme;
    }

    for (const storageKey of THEME_STORAGE_KEYS) {
        const value = window.localStorage.getItem(storageKey);

        if (VALID_THEME_PREFERENCES.has(value)) {
            return value;
        }
    }

    return "system";
}

function resolveTheme(preference) {
    if (preference === "light" || preference === "dark") {
        return preference;
    }

    return window.matchMedia?.("(prefers-color-scheme: dark)")?.matches
        ? "dark"
        : "light";
}

function applyThemePreference(preference = readStoredThemePreference()) {
    const normalizedPreference = VALID_THEME_PREFERENCES.has(preference)
        ? preference
        : "system";
    const resolvedTheme = resolveTheme(normalizedPreference);

    document.documentElement.dataset.themePreference = normalizedPreference;
    document.documentElement.dataset.theme = resolvedTheme;
    document.documentElement.style.colorScheme = resolvedTheme;
}

applyThemePreference();

window.matchMedia?.("(prefers-color-scheme: dark)")?.addEventListener?.("change", () => {
    if (document.documentElement.dataset.themePreference === "system") {
        applyThemePreference("system");
    }
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <ErrorBoundary>
        <React.StrictMode>
            <App />
        </React.StrictMode>
    </ErrorBoundary>
);
